import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InterceptorSkipHeader} from '../helpers/authinterceptor';
import {AuthenticationResponseModel} from '../model/authentication-response.model';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {
  constructor(
    private http: HttpClient,
  ) {
  }

  private loginurl = '';
  private refreshTimeOut: any;

  refreshJwtToken() {
    this.http.get<AuthenticationResponseModel>(
      this.loginurl + '/api/jwtauthentication/refresh-token',
      { 
        headers: new HttpHeaders().set(InterceptorSkipHeader, ''), 
        withCredentials: true, 
      })
      .subscribe((_: AuthenticationResponseModel) => {
        if (_.isSuccess) {
          this.scheduleNextRefreshToken();
          localStorage.setItem('TDOauthToken', _.token);
        } else {
          //if token revoked, delete stored token. Inactivity monitor will pickup empty token and logout
          localStorage.removeItem('TDOauthToken');
          localStorage.removeItem('storedUser');
        }
      });
  }

  refreshPatientJwtToken() {
    this.http.get<AuthenticationResponseModel>(
      this.loginurl + '/api/jwtauthentication/refresh-token',
      { headers: new HttpHeaders().set(InterceptorSkipHeader, ''), withCredentials: true})
      .subscribe((_: AuthenticationResponseModel) => {
        if (_.isSuccess) {
          this.scheduleNextPatientRefreshToken();
          localStorage.setItem('TDOPatientAuthToken', _.token);
        } else {
          localStorage.removeItem('TDOPatientAuthToken');
          localStorage.removeItem('storedPatient');
        }
      });
  }

  scheduleNextRefreshToken() {
    this.clearRefreshTimeout();
    const fifteenMinMs = 60 * 1000 * 15;
    this.refreshTimeOut = setTimeout(() => {
      this.refreshJwtToken();
    }, fifteenMinMs);
  }

  scheduleNextPatientRefreshToken() {
    this.clearRefreshTimeout();
    const fifteenMinMs = 60 * 1000 * 15;
    this.refreshTimeOut = setTimeout(() => {
      this.refreshPatientJwtToken();
    }, fifteenMinMs);
  }

  clearRefreshTimeout() {
    clearTimeout(this.refreshTimeOut);
  }
}
